// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-payment_mollie-card',
    // #endregion
    // #region Properties
    props: {
        gateway: {
            type: Object,
            required: true,
            default: {}
        },
        method: {
            type: Object,
            required: true,
            default: {}
        },
    },
    // #endregion
    // #region Data
    data: () => ({
        cardName: '',
        cardNumberErrors: '',
        cardExpiryDateErrors: '',
        cardVerificationCodeErrors: '',
        cardHolderErrors: '',
        paymentErrors: '',
        elCardNumber: {},
        elCardHolder: {},
        elExpiryDate: {},
        elVerificationCode: {},
        _gateway: {},
        _card: {},
    }),
    // #endregion
    // #region Mount
    beforeMount() {
        //Bus
        this.$host.eventBus.on('checkout-before-commit', this.CreatePaymentMethod);
        //Gateway
        this._gateway = this.$host.provider.get('PAYMENT', this.gateway.clientType);
        //Init
        this._gateway.initialize(this.gateway)
            .then(e => {
            this._gateway.createElement('cardNumber', this.method.element)
                .then(f => {
                this.elCardNumber = f;
                f.mount(this.$refs.card_number);
                f.addEventListener('change', (event) => {
                    if (event.error && event.touched) {
                        this.cardNumberErrors = event.error;
                    }
                    else {
                        this.cardNumberErrors = '';
                    }
                });
            });
            this._gateway.createElement('cardHolder', this.method.element)
                .then(f => {
                this.elCardHolder = f;
                f.mount(this.$refs.card_holder);
                f.addEventListener('change', (event) => {
                    if (event.error && event.touched) {
                        this.cardHolderErrors = event.error;
                    }
                    else {
                        this.cardHolderErrors = '';
                    }
                });
            });
            this._gateway.createElement('expiryDate', this.method.element)
                .then(f => {
                this.elExpiryDate = f;
                f.mount(this.$refs.card_expiryDate);
                f.addEventListener('change', (event) => {
                    if (event.error && event.touched) {
                        this.cardExpiryDateErrors = event.error;
                    }
                    else {
                        this.cardExpiryDateErrors = '';
                    }
                });
            });
            this._gateway.createElement('verificationCode', this.method.element)
                .then(f => {
                this.elVerificationCode = f;
                f.mount(this.$refs.card_verificationCode);
                f.addEventListener('change', (event) => {
                    if (event.error && event.touched) {
                        this.cardVerificationCodeErrors = event.error;
                    }
                    else {
                        this.cardVerificationCodeErrors = '';
                    }
                });
            });
        });
    },
    beforeUnmount() {
        //Elements
        this.elCardNumber.unmount();
        this.elCardHolder.unmount();
        this.elExpiryDate.unmount();
        this.elVerificationCode.unmount();
        //BUS
        this.$host.eventBus.off('checkout-before-commit', this.CreatePaymentMethod);
    },
    // #endregion
    // #region Core
    methods: {
        async CreatePaymentMethod(args) {
            // #region Check
            if (this.cardExpiryDateErrors || this.cardHolderErrors || this.cardNumberErrors || this.cardVerificationCodeErrors) {
                args.cancel = true;
                return;
            }
            // #endregion
            // #region Core
            try {
                //Run
                const { token, error } = await this._gateway.api.createToken();
                if (error) {
                    this.paymentErrors = error.message;
                    args.cancel = true;
                }
                else {
                    args.data.payment.details = {
                        paymentID: token
                    };
                }
            }
            // #endregion
            // #region Error
            catch (error) {
                this.paymentErrors = error;
                args.cancel = true;
            }
            // #endregion
        },
        onPaymentChange(event) {
            if (event.error) {
                this.paymentErrors = event.error.message;
            }
            else {
                this.paymentErrors = '';
            }
        },
    },
    // #endregion
});
// #endregion
